<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
        <circle cx="14" cy="14" r="14" fill="#E9E9E9"/>
        <mask id="bpjwyd36qa" width="15" height="7" x="7" y="14" maskUnits="userSpaceOnUse">
            <path fill="#fff" fill-rule="evenodd" d="M7.28 14.054h13.795v6.74H7.28v-6.74z" clip-rule="evenodd"/>
        </mask>
        <g mask="url(#bpjwyd36qa)">
            <path fill="#A3A3A3" fill-rule="evenodd" d="M16.501 14.054c-.668.434-1.466.688-2.323.688-.849 0-1.638-.25-2.302-.676-2.176 1.02-3.989 3.367-4.596 5.998l1.268.228c3.717.67 7.543.67 11.26 0l1.267-.229c-.74-2.54-2.36-4.972-4.574-6.01" clip-rule="evenodd"/>
        </g>
        <mask id="hk0nhy6pqb" width="8" height="8" x="10" y="6" maskUnits="userSpaceOnUse">
            <path fill="#fff" fill-rule="evenodd" d="M10.821 6.936h6.989v6.989H10.82V6.936z" clip-rule="evenodd"/>
        </mask>
        <g mask="url(#hk0nhy6pqb)">
            <path fill="#A3A3A3" fill-rule="evenodd" d="M14.315 6.936c-1.93 0-3.494 1.565-3.494 3.494 0 1.479.919 2.74 2.216 3.25.396.156.826.245 1.278.245.46 0 .898-.091 1.3-.253 1.286-.516 2.195-1.772 2.195-3.242 0-1.93-1.564-3.494-3.495-3.494" clip-rule="evenodd"/>
        </g>
    </svg>
</template>
<script>
export default { name: 'img-placeholder-icon' }
</script>
